import { SxProps, Theme } from '@mui/system';

const styles = {
  emptyContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingY: '16px',
    alignItems: 'center',
  },
  emptyText: {
    fontSize: 14,
    fontWeight: '500',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
